import { useEffect, useState } from "react";
import { axios, isAxiosError } from "@root/libs/axios";
import { sendErrorLog } from "@root/shared/utils/sendErrorLog";
import { EXCLUDE_EXPERIENCE_IDS } from "@userFrontend/features/promotion/components/Assessment/constants";

type ExperienceResponse = [string, number];

type ErrorResponse = {
  error: string;
};

export const useExperienceOptions = (jobType: number, experienceUrl: string) => {
  const [experiences, setExperiences] = useState<ExperienceResponse[]>([]);
  const [isLoading, setIsLoading] = useState(!!jobType);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!jobType) {
      setExperiences([]);
      setError(null);
      return;
    }

    const fetchExperiences = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await axios.get<ExperienceResponse[]>(experienceUrl, {
          params: { jobType },
        });

        // 「専門学校既卒・在学中」「スクール既卒・在学中」を除外
        const filteredExperiences = response.data.filter(
          ([_label, id]) =>
            !EXCLUDE_EXPERIENCE_IDS.includes(id as (typeof EXCLUDE_EXPERIENCE_IDS)[number]),
        );
        setExperiences(filteredExperiences);
      } catch (err) {
        if (isAxiosError<ErrorResponse>(err)) {
          setError("時間をおいて再度お試しください");
          sendErrorLog(new Error(err.response?.data?.error ?? "経験情報の取得に失敗しました"));
        } else {
          setError("時間をおいて再度お試しください");
          sendErrorLog(
            new Error(err instanceof Error ? err.message : "経験情報の取得に失敗しました"),
          );
        }
        setExperiences([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchExperiences();
  }, [jobType, experienceUrl]);

  return { experiences, isLoading, error };
};
